import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/common/Navbar';
import AgentCreation from './pages/AgentCreation';
import AgentsList from './pages/AgentsList';
import DataViewer from './pages/DataViewer';
import ClientsManagement from './pages/ClientsManagement';

function App() {
  return (
    <div className="App">
      <Navbar />
      <div className="container">
        <Routes>
          <Route path="/agents/new" element={<AgentCreation />} />
          <Route path="/agents" element={<AgentsList />} />
          <Route path="/data" element={<DataViewer />} />
          <Route path="/clients" element={<ClientsManagement />} />
          <Route path="/" element={<Navigate replace to="/agents" />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
